// Typelizer digest bfd4c8f325874c9f6d975dd08518cac9
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /educators/relief/applications/:application_id/response */
  create: (
    params: { applicationId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/educators/relief/applications/:application_id/response', params, options),
    method: 'post',
  }),
}
